import {
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
  EventEmitter,
  AfterViewInit,
  ViewContainerRef,
  ComponentFactoryResolver, ComponentFactory
  , SimpleChanges
} from '@angular/core';
import {Router} from "@angular/router";
import {ImpressaoService} from "../../services/impressao.service";
import {PedidosService} from "../../services/pedidos.service";
import {ModalPedidoAceitarComponent} from "../modal-pedido-aceitar/modal-pedido-aceitar.component";
import {ModalPedidoStatusComponent} from "../modal-pedido-status/modal-pedido-status.component";
import { ModalVincularGarcomComponent } from '../modal-vincular-garcom/modal-vincular-garcom.component';
import {CadEnderecoContatoComponent} from "../cad-endereco-contato/cad-endereco-contato.component";
import {IOperacoesModuloPedidos} from "../../superadmin/services/ioperacoesmodulopedidos";
import {GrupolojasService} from "../../superadmin/services/grupolojas.service";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {RotaGuardClient} from "../../guards/auth-loja.guard";
import {MudarStatusComponent} from "../../componentes/mudar-status/mudar-status.component";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {KendoPopupUtils} from "../../lib/KendoPopupUtils";
import {ServidorImpressaoExecutorService} from "../../services/servidor-impressao-executor.service";


@Component({
  selector: 'app-pedido-acoes',
  templateUrl: './pedido-acoes.component.html',
  styleUrls: ['./pedido-acoes.component.scss']
})
export class PedidoAcoesComponent implements OnInit, AfterViewInit, OnChanges {
 @Input() pedido: any = {};
 @Input() entregadores: any = [];
 @Input() comanda: any ;
 @Input() empresa: any = {};
 @Input() configImpressao: any = {};
 @Input() modoGrupoLojas = false;
  // tslint:disable-next-line:no-output-on-prefix
 @Output() onAtualizouComanda: any = new EventEmitter();
  processando: boolean;
  erroAceitar: string
  opcoesEdicao = [   ];
  opcoesImpressao = [
    'Completo',
    'Resumido'
  ];
  impressoras = [];

  private _podeEditarPedido: boolean;
  EDITARPEDIDO =  'Editar Pedido';
  MUDARSTATUS =   'Mudar Status';
  factory: ComponentFactory<MudarStatusComponent>;

  @Input() set podeEditarPedido(value: boolean) {
    this._podeEditarPedido = value;
    this.recalculeOpcoes();
  }

  get podeEditarPedido(): boolean {

    return this._podeEditarPedido;

  }
  imprimeNativo = false;
  constructor(private router: Router, private impressao: ImpressaoService,
              private grupolojasService: GrupolojasService,  private autorizacaoService: AutorizacaoService,
              private dialogService: DialogService, private pedidosService: PedidosService,
              private servidorImpressaoExecutor: ServidorImpressaoExecutorService,
              private viewContainerRef: ViewContainerRef, private resolver: ComponentFactoryResolver) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.configImpressao) {
      this.carregueImpressorasConfiguradas();
      this.imprimeNativo = this.configImpressao && this.configImpressao.imprimirTXT;
    }

    if (changes && changes.pedido) {
      this.recalculeOpcoes();
    }
  }

  ngOnInit(): void {
    this.carregueImpressorasConfiguradas();

    this.factory = this.resolver.resolveComponentFactory(MudarStatusComponent);


    this.imprimeNativo = this.configImpressao && this.configImpressao.imprimirTXT;
    this.recalculeOpcoes();
  }

  carregueImpressorasConfiguradas() {
    const impressorasConfiguradas = this.configImpressao?.impressoras || [];
    this.impressoras = impressorasConfiguradas.filter((impressora: any) => impressora && !impressora.removida);
  }

  exibeSeletorImpressoras(): boolean {
    return !!this.configImpressao?.multiplasImpressoras && this.impressoras.length > 1;
  }

  possuiImpressoraUnicaConfigurada(): boolean {
    return !!this.configImpressao?.multiplasImpressoras && this.impressoras.length === 1;
  }

  obtenhaImpressoraPadrao(): any {
    return this.impressoras[0] || null;
  }

  ngAfterViewInit(): void {
    this.apliqueRestricoesDePermissao();

  }

  private recalculeOpcoes(): void {
    // Recalcula toda vez que o pedido mudar (Kendo reaproveita componentes de célula).
    const pedido = this.pedido || {};

    // Evita “vazamento” de estado entre linhas ao trocar o pedido.
    if (pedido.multipedido) {
      this.opcoesEdicao = [];
      return;
    }

    if (this._podeEditarPedido && pedido.podeEditar) {
      this.opcoesEdicao = [this.EDITARPEDIDO, this.MUDARSTATUS];

      if (pedido.endereco) {
        this.opcoesEdicao.push('Alterar Endereço');
      }
    } else {
      this.opcoesEdicao = [this.MUDARSTATUS];
    }

    this.apliqueRestricoesDePermissao();
  }

  private apliqueRestricoesDePermissao(): void {
    const user = this.autorizacaoService.getUser();

    if(!RotaGuardClient.alterarPedido(user)){
      const i = this.opcoesEdicao.indexOf(this.MUDARSTATUS);
      if (i >= 0) this.opcoesEdicao.splice(i, 1);
    }

    if(!RotaGuardClient.editarPedido(user)){
      const i = this.opcoesEdicao.indexOf(this.EDITARPEDIDO);
      if (i >= 0) this.opcoesEdicao.splice(i, 1);
    }
  }



  escolheuOpcaoEditar(opcao: any, pedido: any) {
    if(opcao === 'Finalizar Pedido'){
       this.finalizarPedido(pedido)
    } else if( opcao === 'Editar Pedido' ) {
        this.editarPedido(pedido);
    }  else if( opcao === 'Alterar Endereço' ) {
        this.abraModalEditarEndereco(pedido);
    } else {
      this.mudarStatusPedido(pedido);
    }
  }

  abraModalEditarEndereco(pedido) {

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: CadEnderecoContatoComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)

    windowRef.content.instance.setEndereco(pedido.endereco, true);

    windowRef.result.subscribe((result: any) => {
      if(result && result.id) {
        pedido.endereco = Object.assign(pedido.endereco, result);
        pedido.enderecoCompleto = result.enderecoCompleto;
      }
    } );

  }

  editarPedido(pedido: any){
    let linkPedido = '/admin/pedidos/' + pedido.guid;

    if(!this.modoGrupoLojas){
      this.router.navigateByUrl(linkPedido).then ( () => {});
    } else {
      window.open(String(`https://${this.pedido.empresa.dominio}.meucardapio.ai${linkPedido}`))
    }

  }

  finalizarPedido(pedido: any){
    let dados =  { contato: pedido.cliente, pedido: pedido, empresa:  {}}

    this.router.navigateByUrl('/admin/pedidos/finalizar-mesa/' + pedido.codigo + '?urlRetorno=' + location.pathname, { state: dados})
  }

  mudarStatusPedido(pedido: any) {

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalPedidoStatusComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)


    windowRef.content.instance.modoGrupoLojas = this.modoGrupoLojas
    windowRef.content.instance.idEmpresa = pedido?.empresa?.id
    windowRef.content.instance.pedido = pedido
    windowRef.content.instance.contato = pedido.contato;


    windowRef.result.subscribe( (result: any) => {
        if(result && result.id)
          Object.assign(pedido, result)

        if(result && result.cancelado)
          this.onAtualizouComanda.emit( this.comanda);

      },
      (a) => {
      });


  }

  imprimaLayoutUnico(){
    let layout: string = this.configImpressao ? this.configImpressao.layoutPedido : null;

    if(this.configImpressao && this.configImpressao.imprimirTXT){
      this.imprimaNativamenteNoLayout(layout);
    } else {
      this.abraAbaImprimir(this.pedido , layout)
    }
  }

  prevenirSelecao(evt: MouseEvent): boolean {
    evt.stopPropagation();
    evt.preventDefault();
    return false;
  }

  imprimaUmDosLeiautes(opcao: any) {
    let leiaute = opcao === 'Completo' ? 'PedidoCompleto' : 'PedidoResumido';

    if(this.configImpressao && this.configImpressao.imprimirTXT){
      this.imprimaNativamenteNoLayout(leiaute);
    } else {
      this.abraAbaImprimir(this.pedido, leiaute)
    }
  }

  abraAbaImprimir(pedido: any, layoutPedido: any) {
    let link = '/imprimir/pedido/' + pedido.guid

    if(layoutPedido)
      link += '?l=' + layoutPedido

    if(this.modoGrupoLojas && pedido?.empresa?.dominio)
      link = `https://${pedido.empresa.dominio}.meucardapio.ai${link}`;

    window.open(link);
  }

 async imprimaNativamenteNoLayout(leiaute: string){
    const pedidoCompleto = await this.carreguePedidoCompletoParaImpressaoGrupo();
    const impressoraPadrao = this.obtenhaImpressoraPadrao();

    if(!impressoraPadrao) {
      this.impressao.onErrosImpressao.emit('Nenhuma impressora configurada');
      return;
    }

    const impressora = {
      ...impressoraPadrao,
      layout: this.obtenhaLayoutPadrao(impressoraPadrao, leiaute)
    };

    await this.imprimaNativamente(impressora, pedidoCompleto)
  }

 async imprimaNativamente(impressora: any, pedidoCompletoGrupo: any = null) {
    if(!impressora) {
      this.impressao.onErrosImpressao.emit('Nenhuma impressora configurada');
      return;
    }

    const impressoraSelecionada = {...impressora};
    const layout = this.obtenhaLayoutPadrao(impressoraSelecionada);

    if(layout)
      impressoraSelecionada.layout = layout;

    if(this.modoGrupoLojas) {
      await this.imprimaNativamenteGrupo(impressoraSelecionada, pedidoCompletoGrupo);
      return;
    }

    if(!impressoraSelecionada.servidorImpressao){
      await this.impressao.imprimaQzTray(this.pedido, impressoraSelecionada)
    } else {
      await this.impressao.envieImprimirRemotamente(this.pedido, impressoraSelecionada);
    }
  }

  private async carreguePedidoCompletoParaImpressaoGrupo(): Promise<any> {
    if(!this.modoGrupoLojas) return null;

    const idEmpresa = this.pedido?.empresa?.id;
    if(!idEmpresa || !this.pedido?.guid) return null;

    const pedidoCompleto = await this.grupolojasService.obtenhaPorGuid(this.pedido.guid, idEmpresa).catch((erro) => {
      this.impressao.marqueErroImpresso(this.pedido, 'Falha ao carregar pedido: ' + erro);
      this.impressao.onErrosImpressao.emit(this.pedido.erroImpressao);
      return null;
    });

    const configImpressao = pedidoCompleto?.empresa?.configImpressao;
    if(configImpressao) {
      this.configImpressao = configImpressao;
      this.carregueImpressorasConfiguradas();
    }

    return pedidoCompleto;
  }

  private async imprimaNativamenteGrupo(impressora: any, pedidoCompleto: any = null) {
    const idEmpresa = this.pedido?.empresa?.id;

    if(!idEmpresa) {
      this.impressao.onErrosImpressao.emit('Não foi possível identificar a loja do pedido para impressão');
      return;
    }

    if(!pedidoCompleto)
      pedidoCompleto = await this.carreguePedidoCompletoParaImpressaoGrupo();

    if(!pedidoCompleto) return;

    if(impressora.servidorImpressao) {
      await this.impressao.envieImprimirRemotamente(pedidoCompleto, impressora);
      return;
    }

    this.impressao.marquePedidoImprimir(this.pedido);

    await this.impressao.imprimaPedidoNaImpressora(pedidoCompleto, impressora, this.pedido, {
      configImpressao: this.configImpressao,
      categorias: pedidoCompleto?.empresa?.catalogo?.categorias || this.pedido?.empresa?.catalogo?.categorias || [],
      marquePedidoImpresso: async (pedidoMarcado: any, impressaoAuto: boolean) => {
        await this.grupolojasService.marqueFoiImpresso(pedidoMarcado, idEmpresa, impressaoAuto);
      }
    });
  }

  private obtenhaLayoutPadrao(impressora: any = null, layoutPedido: string = null): string {
    let layout = layoutPedido || impressora?.layout || this.configImpressao?.layoutPedido;

    if(layout === 'Completo')
      return 'PedidoCompleto';

    if(layout === 'Resumido')
      return 'PedidoResumido';

    if(layout === 'Ambos')
      return 'PedidoCompleto';

    return layout;
  }

  abraModalVincularGarcom(pedido: any){

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalVincularGarcomComponent,
      minWidth: 250,
      width: window.innerWidth > 500 ? 500 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)


    windowRef.content.instance.empresa =  this.empresa;
    windowRef.content.instance.comanda = this.comanda;

    if( this.pedido.garcom)
      windowRef.content.instance.setGarcom( this.pedido.garcom)

    windowRef.result.subscribe( (comanda: any) => {
        if(comanda && comanda.id)
          this.onAtualizouComanda.emit(comanda);
      });
  }

  abraModalVerPedido(pedido: any){
    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalPedidoAceitarComponent,
      minWidth: 250,
      width: window.innerWidth > 800 ? 800 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)

    windowRef.content.instance.empresa = this.empresa;
    windowRef.content.instance.pedido = pedido

    windowRef.result.subscribe( (result: any) => {
        if(result && result.id)
          Object.assign(pedido, result)
      },
      (a) => {
      });
  }
  notifiqueSistemaIntegrado($event) {
    if( this.processando ) return;

    delete this.erroAceitar;
    this.processando = true;

    this.getService().notifiqueSistemaIntegrado(this.pedido).then( (resp) => {
      this.pedido.referenciaExterna = resp;
      this.pedido.naoNotificado = false;
      this.processando = false;
    }).catch( erro => {
      this.processando = false;
      this.erroAceitar = erro;
      alert(erro)
    })

    if($event){
      $event.stopPropagation();
      $event.preventDefault();
    }
  }


  getService(): IOperacoesModuloPedidos {
    if (this.modoGrupoLojas)
      return this.grupolojasService;

    return this.pedidosService;
  }
}
